<div class="navbar-top" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">
    <div class="logo">
        <!-- <img class="logo-icon" src="assets/icons/icon_gurumatch_branco.png">
        <span class="logo-text secondary-text">GURUMATCH1</span> -->

        <img class="logo-icon" [src]="currentTheme.images.adminLogoUrl" *ngIf="currentTheme?.images?.adminLogoUrl" />
        <span class="logo-text" *ngIf="!currentTheme?.images?.adminLogoUrl">
            {{ subscription?.name }}
        </span>
    </div>

    <div class="buttons">
        <button
            [id]="'button_style-1_ToggleMenu'"
            mat-icon-button
            class="toggle-sidebar-folded"
            (click)="toggleSidebarFolded()"
            fxHide.lt-lg
        >
            <mat-icon class="secondary-text">menu</mat-icon>
        </button>

        <button
            [id]="'button_style-1_Back'"
            mat-icon-button
            class="toggle-sidebar-opened"
            (click)="toggleSidebarOpened()"
            fxHide.gt-md
        >
            <mat-icon class="secondary-text">arrow_back</mat-icon>
        </button>
    </div>
</div>

<div
    class="navbar-scroll-container"
    [ngClass]="fuseConfig.layout.navbar.primaryBackground"
    fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{ suppressScrollX: true }"
>
    <!-- <div class="user" fxLayout="column" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

        <div class="h3 username">Charlie Adams</div>
        <div class="h5 email hint-text mt-8">adams.charlie@mail.com</div>
        <div class="avatar-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground">
            <img class="avatar" src="assets/images/avatars/Velazquez.jpg">
        </div>

    </div> -->

    <div class="navbar-content">
        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
    </div>

    <div class="navbar-footer">
        <div fxLayout="row" fxLayoutAlign="start center" class="w-100-p" class="help-section">
            <app-help-section fxFlex></app-help-section>
        </div>

        <div class="poweredby-logo">
            <poweredby-logo *ngIf="!subscription.theme.poweredByLogoUrl"></poweredby-logo>
            <img *ngIf="subscription.theme.poweredByLogoUrl" [src]="subscription.theme.poweredByLogoUrl" alt="" />
        </div>
    </div>
</div>
